export const GRADES_ENDPOINTS = {
  BASE: "/v1/grades",
  DETAIL: (id: string) => `/v1/grades/${id}`,
} as const;
